export const getMarketFromHostname = () => {
  const hostname = window.location.hostname;
  if (hostname.includes('.dk')) return 'dk';
  if (hostname.includes('.se')) return 'sv';
  return 'no';
};

const FOOTER_LINKS_BY_MARKET = {
  no: {
    privacyPolicy: 'https://about.hudd.no/retningslinjer_for_personvern',
    termsOfUse: 'https://about.hudd.no/vilkar_for_bruk',
    supportLink: 'support@hudd.no',
  },
  dk: {
    privacyPolicy: 'https://about.hudd.dk/privatlivserklæring',
    termsOfUse: 'https://about.hudd.dk/vilkar_for_brug',
    supportLink: 'support@hudd.dk',
  },
  sv: {
    privacyPolicy: 'https://about.hudd.se/integritetspolicy',
    termsOfUse: 'https://about.hudd.se/villkor_for_anvandning',
    supportLink: 'support@hudd.se',
  },
};

export const getFooterLinks = () =>
  FOOTER_LINKS_BY_MARKET[getMarketFromHostname()];
